import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CountryLink from 'Components/common/CountryLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { getCountryOverallTrend } from 'Utils/calcOverallTrend';

const atlas = new AtlasMetadataClient();

const TopDailyList = ({ globalStatistics, locale, content, region, sitePrefix, metric = 'cases' }) => {
  const { latestWeeklyAvgs } = globalStatistics;

  const countryList = atlas.getRegion(region).countries.map(c => c.isoAlpha2);

  const countries = Object.keys(latestWeeklyAvgs[metric])
    .filter(c => countryList.includes(c))
    .filter(c => latestWeeklyAvgs[metric][c][3] >= 1);
  countries.sort((a, b) => latestWeeklyAvgs[metric][b][3] - latestWeeklyAvgs[metric][a][3]);

  const topListData = countries.slice(0, 5).map(c => {
    const latestAvg = latestWeeklyAvgs[metric][c][3];

    const country = atlas.getCountry(c);
    const trend = getCountryOverallTrend(globalStatistics, country.isoAlpha2)[metric];

    return (
      <div className='country-row' key={c}>
        <div className='trend-indicator'>
          {trend.increasing && (
            <FontAwesomeIcon icon={faCaretUp} />
          )}
          {trend.decreasing && (
            <FontAwesomeIcon icon={faCaretDown} />
          )}
        </div>
        <div className='country-title'>
          <CountryLink country={c} locale={locale} sitePrefix={sitePrefix} />
          <span>{Math.round(latestAvg).toLocaleString(locale)}</span>
        </div>
        <div className='trend-line'>
          <img src={`//graphics.thomsonreuters.com/data/2020/coronavirus/global-tracker/countries/${country.slug}/charts/${metric}.svg`} />
        </div>
      </div>
    );
  });

  return (
    <>
      <div className='font-sans list-container'>
        {topListData}
      </div>
    </>
  );
};

export default TopDailyList;
